export default {
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.create': 'Create',
  'common.ok': 'OK',
  'common.confirm': 'Confirm',
  'common.note': 'Note',
  'common.copied': 'Copied!',
  'common.permanentDelete': 'Permanently delete',
};
